import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CheckboxModule } from '@appkit4/angular-components/checkbox';
import { FieldModule } from '@appkit4/angular-components/field';
import { ModalModule } from '@appkit4/angular-components/modal';
import { PanelModule } from '@appkit4/angular-components/panel';
import { SharedModule } from '@shared/shared.module';
import { AuditHistoryRoutingModule } from './audit-history-routing.module';
import { AuditHistoryComponent } from './components/audit-history/audit-history.component';
import { SecurityAuditService } from './services/security-audit.service';
import { PrimeGridFiltersModule } from '@shared/modules/prime-grid-filters/prime-grid-filters.module';
import { GridModule } from '@shared/modules/grid/grid.module';

@NgModule({
  declarations: [AuditHistoryComponent],
  imports: [
    CommonModule,
    SharedModule,
    AuditHistoryRoutingModule,
    ReactiveFormsModule,
    FieldModule,
    ModalModule,
    PanelModule,
    FormsModule,
    CheckboxModule,
    GridModule,
    PrimeGridFiltersModule,
  ],
  exports: [],
  providers: [SecurityAuditService],
})
export class AuditHistoryModule {}
